@if(hasVisibleChildren()) {
  <div class="accordion-container">
    <ion-accordion-group
      [class]="(options.formState.showCompactViewWhenDisabled ? 'disabled-form-' : '') + 'accordion'" 
      [value]="(!options.formState.disabled || field.props?.['defaultExpanded']) ? 'accordion-open' : undefined">
      <ion-accordion value="accordion-open">
        <ion-item slot="header" class="accordion-header">
          <ion-label>{{ props['label']! | translate }}</ion-label>
        </ion-item>
        <div slot="content" class="accordion-content">
          <ng-container #fieldComponent></ng-container>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
}